module.exports = __webpack_public_path__ + "static/media/STCS.14a2c4bf.svg";